import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for delete  trade setup
export const DeleteTreadSetup = createSlice({
  name: "DeleteTreadSetup",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    delete_TreadSetup: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_delete_TreadSetup: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_delete_TreadSetup: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    delete_TreadSetup_is_success: (state, action) => {
      state.isSuccess = false;
    },
    false_switchdeleteTreadSetup_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default DeleteTreadSetup.reducer;
export const {
  delete_TreadSetup,
  success_api_call_delete_TreadSetup,
  failure_api_call_delete_TreadSetup,
  delete_TreadSetup_is_success,
  false_switchdeleteTreadSetup_response
} = DeleteTreadSetup.actions;
